import React from 'react';
import {
	EscalaPdfPreview,
	exportarPdfGridEscala,
} from '../Escala Medica/PDFgrid';

export const SHOW_ESCALA_ENFERMAGEM_PDF_PREVIEW =
	process.env.NODE_ENV === 'development' &&
	String(process.env.REACT_APP_SHOW_ESCALA_PDF_PREVIEW || '').toLowerCase() ===
		'true';

const getRegimeEnfermagem = (data = {}) =>
	data?.contexto?.regime ||
	data?.contexto_competencia?.regime ||
	data?.resumo?.regime ||
	'';

/**
 * Mantém a exportação de enfermagem no mesmo desenho da grade mensal atual:
 * cards, cores, vínculo e grupos de categoria seguem a base compartilhada
 * da escala médica. A exportação continua dividindo o mês em páginas para
 * preservar legibilidade no PDF.
 */
export const EscalaEnfermagemPdfPreview = (props) => (
	<EscalaPdfPreview
		{...props}
		agruparPorEspecialidade
		regime={props?.regime || getRegimeEnfermagem(props?.data)}
	/>
);

export const exportarPdfGridEscalaEnfermagem = async (args = {}) =>
	exportarPdfGridEscala({
		...args,
		agruparPorEspecialidade: true,
		regime: args?.regime || getRegimeEnfermagem(args?.data),
	});
